// @ts-strict-ignore
import { FC } from 'react'

import { Section } from '@/screens/Sitemap/ui'

import { Container } from '@/shared/ui/Container'

import { SitemapProps } from './types'

import styles from './Sitemap.module.scss'

export const Sitemap: FC<SitemapProps> = ({
	catalogSections,
	pageSections,
	brands,
	used,
	markdowns,
	seolinks,
	services
}) => {
	return (
		<div className={styles.container}>
			<Container>
				<h1 className={styles.title}>Карта сайта</h1>

				{/* Все страницы сайта */}
				{pageSections.map((section, index) => (
					<Section key={index} title={section.title} items={section.pages} expandable={true} />
				))}

				{/* Разделы каталога */}
				<Section
					title="Каталог товаров"
					items={catalogSections
						.filter(section => !section.title.includes('Баннер'))
						.map(section => ({
							title: section.title,
							path: section.path,
							children: section.subsections?.map(sub => ({
								title: sub.title,
								path: sub.path,
								children: sub.links
							}))
						}))}
					expandable={true}
				/>

				{/* Б/У товары */}
				{used?.categories.length > 0 && (
					<Section
						title="Б/у товары"
						items={used.categories.map(category => ({
							title: category.NAME,
							path: `/discount/catalog/${category.LINK}`
						}))}
					/>
				)}

				{/* Уцененные товары */}
				{markdowns?.categories.length > 0 && (
					<Section
						title="Уцененные товары"
						items={markdowns.categories.map(category => ({
							title: category.NAME,
							path: `/markdown/${category.LINK}`
						}))}
					/>
				)}

				{/* Бренды */}
				<Section
					title="Бренды"
					items={brands.map(brandData => ({
						title: brandData.brand.NAME,
						path: `/brand/${brandData.brand.CODE}`
					}))}
					expandable={true}
				/>

				{/* SEO-links */}
				{seolinks?.length > 0 && (
					<Section
						title="Страницы с фильтрами"
						items={seolinks.map(category => ({
							title: category.TITLE,
							path: category.URL
						}))}
					/>
				)}

				{/* Услуги */}
				{services?.length > 0 && (
					<Section
						title="Услуги сервисных центров"
						items={services.map(section => ({
							title: section.name,
							path: section.url,
							children: section.elements?.map(element => ({
								title: element.name,
								path: element.url
							}))
						}))}
						expandable={true}
					/>
				)}
			</Container>
		</div>
	)
}
